export type ProgressTone = "brand" | "info" | "success" | "danger";

export interface ProgressBarProps {
  value: number; // 0..100
  tone?: ProgressTone;
  ariaLabel?: string;
}

/** Clampa a 0..100 para evitar barras desbordadas. */
export function clampPercent(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(100, value));
}

export function ProgressBar({ value, tone = "brand", ariaLabel }: ProgressBarProps): JSX.Element {
  const pct = clampPercent(value);
  const toneClass = tone === "brand" ? "" : `progress--${tone}`;
  return (
    <div
      className={`progress ${toneClass}`.trim()}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
    >
      <div className="progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
